import { derived, writable } from 'svelte/store'
import { treq } from '#app/lib/treq'
import type { ControllersAPI } from '#server/types/controllers_api'
import type { GroupId } from '#server/types/group'
import type { UserId } from '#server/types/user'
import { getGroupById, getMainUserGroupStatus, serializeGroup, type SerializedGroup } from './groups'

export let userGroups: SerializedGroup[] = []

export const userGroupsStore = writable(userGroups)

async function fetchUserGroups () {
  const res = await treq('groups', 'get', 'default')
  userGroups = res.groups.map(group => serializeGroup(group))
  userGroupsStore.set(userGroups)
}

let fetchingUserGroups
export async function getUserGroups () {
  fetchingUserGroups ??= fetchUserGroups()
  await fetchingUserGroups
  return userGroups
}

export async function getGroupInvitations () {
  const groups = await getUserGroups()
  return groups.filter(group => getMainUserGroupStatus(group) === 'invited')
}

export const userGroupsInvitationsCount = derived(userGroupsStore, ($userGroupsStore: SerializedGroup[]) => {
  return $userGroupsStore.filter(group => getMainUserGroupStatus(group) === 'invited').length
})

export async function createGroup (groupData: ControllersAPI['groups']['post']['default']['params']) {
  const group = await treq('groups', 'post', 'default', groupData)
  const serializedGroup = serializeGroup(group)
  updateUserGroups(serializedGroup)
  return serializedGroup
}

export type GroupMembershipAction = Exclude<keyof ControllersAPI['groups']['put'], 'update-settings'>

export async function groupAction ({ action, groupId, userId }: { action: GroupMembershipAction, groupId: GroupId, userId?: UserId }) {
  await treq('groups', 'put', action, {
    group: groupId,
    // Required only for actions implying an other user
    user: userId,
  })
  const updatedGroup = await getGroupById(groupId)
  const serializedGroup = serializeGroup(updatedGroup)
  updateUserGroups(serializedGroup)
  return serializedGroup
}

function updateUserGroups (group: SerializedGroup) {
  if (getMainUserGroupStatus(group) === 'member') {
    if (!userGroups.find(g => g._id === group._id)) userGroups.push(group)
  } else {
    userGroups = userGroups.filter(g => g._id !== group._id)
  }
  userGroupsStore.set(userGroups)
}
